import './ferramentas.css';
import { Link } from 'react-router-dom';

export default function Ferramentas() {
    return(
        <section className="containerSecao">

            <div className='containerExperiencias'>
                <h3 className='tituloExperiencia'>EXPERIÊNCIAS DE TRABALHO</h3>
                <div className='experiencia'>   
                    <span className='job'>Front-End</span>
                    <span className='tipoJob'>Freelance</span>
                    <p className='textJob'>
                        Atuando no Desenvolvimento de Landing Pages, e One Pages para apresentação de Pequenos Comercios
                    </p>

                    <p className='textJob'>
                        Usando as Ferramentas <strong>HTML, CSS, Javascript e ReactJS</strong> no desenvolvimento de Landing Pages e One Pages
                    </p>
                </div>
                <div className='experiencia'>   
                    <span className='job'>Analista de Pricing & Dados</span>
                    <span className='tipoJob'>Supermercados Dalben - Campinas SP</span>
                    <p className='textJob'>
                        Atuando na Area de Pricing e Dados na Rede de Varejo Supermercados Dalben de Campinas SP, apoiando o Time em novos Desenvolvimentos de estrategias, apoiando na preservação de Margem e precificação da rede.
                    </p>
                    <p className='textJob'>
                        Apoiando também na Frente de analise de dados trazendo relatórios para apoiar o Time Comercial para que possam tomar decisões assertivas.
                    </p>
                    <p className='textJob'>
                        Usando as ferramentas no Dia a Dia como, <strong>Oracle - PL/SQL</strong> para montagem de relatórios inteligentes. <strong>Python</strong> para Produtividade como Desenvolvimento de RPAs para suprir as tarefas repetitivas do dia a dia. <strong>Ms EXCEL</strong> para mostragem dos dados minerados e organização dos dados.
                    </p>
                </div>

                <h3 className='tituloExperiencia'>PROJETOS FRONT-END WEB</h3>
                <div className='experiencia'>   
                    <span className='job'>Front-End</span>
                    <span className='tipoJob'>Projetos Pessoais</span>
                    <p className='textJob'>
                        Projetos Feitos para praticar os conteudos aprendidos, sempre buscando evoluir a cada dia.
                    </p>

                    <p className='textJob'>
                        Acesse clicando no Botão Abaixo
                    </p>

                    <Link className='btnProjetos' to= '/projetos'>
                        Meus Projetos
                    </Link>
                    
                </div>
                


            </div>

            <div className='containerFerramentas'>
                <h3>FERRAMENTAS</h3>
                <div className='ferramenta'>   
                    <span className='skill'>HTML & CSS</span>
                    <p className='textSkill'>
                        Desenvolvimento de Paginas Web, com a base fundamental para construção de Páginas Semanticas e Responsivas, com a base sólida ao modelo de caixas(Box Model), posicionamento de elementos com Flexbox e tratamentos dos elementos com CSS.
                    </p>
                </div>
                <div className='ferramenta'>   
                    <span className='skill'>Javascript & ReactJS</span>
                    <p className='textSkill'>
                        Usando Javascript e ReactJS, para dar dinamismo as paginas Web,  validações de formularios e usando o modelo de componentes para reaproveitando de Código deixando menos Verboso e legivel.
                    </p>
                </div>
                <div className='ferramenta'>   
                    <span className='skill'>Banco de Dados SQL</span>
                    <p className='textSkill'>
                        Usando SQL para criação de consultas inteligentes em Banco de Dados Relacional (MySQL e Oracle PLSQL)
                    </p>
                </div>
                <div className='ferramenta'>   
                    <span className='skill'>Python</span>
                    <p className='textSkill'>
                        Usando Python no Dia a Dia, para tornar pratico os esforços repetitivos desenvolvendo RPAS para suprir as demandas.
                    </p>
                </div>
                <div className='ferramenta'>   
                    <span className='skill'>Microsoft Excel & ETL</span>
                    <p className='textSkill'>
                        Usando para organizar os dados minerados com SQL e trazer uma forma legivel para leitura e entendimento dos dados.
                    </p>
                </div>
                <div className='ferramenta'>   
                    <span className='skill'>Git e Github</span>
                    <p className='textSkill'>
                        Usando para armazenamento de Código e Versionamento.
                    </p>
                </div>
                
                <div className='ferramenta'>   
                    <span className='skill'>Totvs ERP Linha Consinco</span>
                    <p className='textSkill'>
                        Experiencia com ERP Totvs Linha Consinco, nas aplicações de Acrux Cadastro - Cadastro de Produtos e Familias entre outros Modulo dentro da Aplicação.
                    </p>
                    <p className='textSkill'>
                        Acrux Preço - Gerenciador de Precificação entendimento sólido da aplicação.
                    </p>
                    <p className='textSkill'>
                        Query View - Criação de Visões em SQL para consultas prontas no Modulo Query View.
                    </p>

                    <p className='textSkill'>
                        E entre outras aplicações na Area Comercial.
                    </p>
                </div>
                
            </div>
            
        </section>
    );
}